import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePageUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateThemePageInput;
}>;

export type ThemePageUpdateMutationResponse = {
  themePageUpdate?: Types.Maybe<
    Pick<
      Types.ThemePage,
      | 'createdAt'
      | 'default'
      | 'description'
      | 'id'
      | 'name'
      | 'splitPercentage'
      | 'status'
      | 'type'
      | 'updatedAt'
    >
  >;
};

export const ThemePageUpdateDocument = `
    mutation ThemePageUpdate($id: ID!, $input: UpdateThemePageInput!) {
  themePageUpdate(id: $id, input: $input) {
    createdAt
    default
    description
    id
    name
    splitPercentage
    status
    type
    updatedAt
    status
  }
}
    `;

export const useThemePageUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ThemePageUpdateMutationResponse,
    TError,
    ThemePageUpdateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ThemePageUpdateMutationResponse,
    TError,
    ThemePageUpdateMutationVariables,
    TContext
  >(
    ['ThemePageUpdate'],
    (variables?: ThemePageUpdateMutationVariables) =>
      appFetcher<ThemePageUpdateMutationResponse, ThemePageUpdateMutationVariables>(
        ThemePageUpdateDocument,
        variables,
      )(),
    options,
  );
};

useThemePageUpdateMutation.getKey = () => ['ThemePageUpdate'];
